import React from 'react'
import { Field } from 'redux-form'

import InputFieldComponent from '../component/InputFieldComponent'

const BusinessTypeField = () => <Field name="address" component={InputFieldComponent} />

export default BusinessTypeField
